<!--
  Popover warning per conferma sincronizzazione ordine (v2.11.0 J.3).
  Backdrop fisso + dialog centrato a z-index 2100 (sopra modale parent 2000).
-->
@if (openedWarningMessage) {
  <div
    class="pw-backdrop"
    (click)="cancel()"
  >
    <div
      class="pw-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pw-title"
      (click)="$event.stopPropagation()"
    >
      <header class="pw-header">
        <div class="pw-icon">
          <i class="bx bx-error"></i>
        </div>
        <h2 id="pw-title">Sincronizzazione ordine</h2>
        <button
          type="button"
          class="pw-close"
          aria-label="Chiudi"
          (click)="cancel()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <div class="pw-body">
        <p class="pw-msg">
          <strong>Attenzione:</strong> questa azione comporterà modifiche
          significative all'ordine, incluse ma non limitate a prodotti
          aggiunti/rimossi, indirizzo di spedizione, ecc.
        </p>
        <p class="pw-hint">
          Premi "Continua" se sei d'accordo.
        </p>
      </div>

      <footer class="pw-actions">
        <button
          type="button"
          class="pw-btn pw-btn--confirm"
          (click)="confirm()"
        >
          <i class="bx bx-check-circle"></i>
          Continua
        </button>
        <button
          type="button"
          class="pw-btn pw-btn--cancel"
          (click)="cancel()"
        >
          <i class="bx bx-x"></i>
          Annulla
        </button>
      </footer>
    </div>
  </div>
}
